import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useEffect, useState } from 'react';
import { Typography, ToggleButtonGroup, ToggleButton, InputLabel, InputAdornment, FormControl, OutlinedInput, ListItem } from '@mui/material';
import { useTranslation } from 'react-i18next';
// import { BackdropLoader } from '@livable/saas-react-components';
import { observer } from 'mobx-react-lite';
import { useStore } from 'src/stores';
import useStyles from './styles';
import { FEE_UNIT_TYPES } from 'src/constants/feesSetting';
export const LateFee = observer(() => {
  var _store$addNewProperty, _store$addNewProperty2, _store$addNewProperty3, _store$addNewProperty4, _store$addNewProperty5, _store$addNewProperty6, _store$addNewProperty7, _store$addNewProperty8;
  const store = useStore();
  const classes = useStyles();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const feeName = 'lateFee';

  // Note: Just made a quick implementation for new LateFee LB-1901
  const feeCurrency = (_store$addNewProperty = (_store$addNewProperty2 = store.addNewProperty.feeStructureV2.getPropertyFee({
    feeName
  })) === null || _store$addNewProperty2 === void 0 ? void 0 : _store$addNewProperty2.feeUnitType) !== null && _store$addNewProperty !== void 0 ? _store$addNewProperty : FEE_UNIT_TYPES.fixedAmount;
  const isFeeExcluded = () => {
    return store.addNewProperty.feeStructureV2.getPropertyFee({
      feeName
    }) === null;
  };
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isInputTouched = _useState2[0],
    setInputTouched = _useState2[1];
  const feeUnitType = (_store$addNewProperty3 = store.addNewProperty.feeStructureV2.getPropertyFee({
    feeName
  })) !== null && _store$addNewProperty3 !== void 0 && _store$addNewProperty3.feeUnitType ? (_store$addNewProperty4 = store.addNewProperty.feeStructureV2.getPropertyFee({
    feeName
  })) === null || _store$addNewProperty4 === void 0 ? void 0 : _store$addNewProperty4.feeUnitType : '';
  const inputValue = (_store$addNewProperty5 = store.addNewProperty.feeStructureV2.getPropertyFee({
    feeName
  })) !== null && _store$addNewProperty5 !== void 0 && _store$addNewProperty5.value ? (_store$addNewProperty6 = store.addNewProperty.feeStructureV2.getPropertyFee({
    feeName
  })) === null || _store$addNewProperty6 === void 0 ? void 0 : _store$addNewProperty6.value : '';
  const handleTouched = () => {
    if (!isInputTouched) setInputTouched(true);
  };
  const handleFeeChange = (e, value) => {
    if (value === 'exclude-fee') {
      store.addNewProperty.feeStructureV2.updateFee({
        feeName,
        value: null
      });
      store.addNewProperty.feeStructureV2.validateFees(true);
    } else {
      store.addNewProperty.feeStructureV2.updateLateFee({
        feeUnitType: FEE_UNIT_TYPES.fixedAmount,
        value: ''
      });
      store.addNewProperty.feeStructureV2.validateFees(false);
      setInputTouched(true);
    }
  };
  const handleSignChange = (e, value) => {
    if (value) {
      store.addNewProperty.feeStructureV2.updateFee({
        feeName,
        feeUnitType: value
      });
    }
  };
  const inputHandleChange = value => {
    store.addNewProperty.feeStructureV2.updateLateFee({
      feeUnitType,
      value
    });
    store.addNewProperty.feeStructureV2.validateFees(+value > 0);
  };
  useEffect(() => {
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return /*#__PURE__*/React.createElement(ListItem, {
    variant: "evenWrapper"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Typography, {
    variant: "h4"
  }, t('add_new_property_flow.late_fee_warning')), /*#__PURE__*/React.createElement("div", {
    className: classes.xsSection
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body1"
  }, t('add_new_property_flow.late_fee_description'))), /*#__PURE__*/React.createElement("div", {
    className: classes.controlsWrapper
  }, /*#__PURE__*/React.createElement(ToggleButtonGroup, {
    value: isFeeExcluded() ? 'exclude-fee' : 'set-fee',
    onChange: handleFeeChange,
    exclusive: true
  }, /*#__PURE__*/React.createElement(ToggleButton, {
    value: "exclude-fee"
  }, t('add_new_property_flow.exclude_this_fee')), /*#__PURE__*/React.createElement(ToggleButton, {
    value: "set-fee"
  }, t('add_new_property_flow.set_this_fee'))), !isFeeExcluded() && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ToggleButtonGroup, {
    exclusive: true,
    onChange: handleSignChange,
    className: "".concat(classes.signToggler),
    value: (_store$addNewProperty7 = store.addNewProperty.feeStructureV2.getPropertyFee({
      feeName
    })) === null || _store$addNewProperty7 === void 0 ? void 0 : _store$addNewProperty7.feeUnitType
  }, /*#__PURE__*/React.createElement(ToggleButton, {
    value: FEE_UNIT_TYPES.fixedAmount
  }, "$"), /*#__PURE__*/React.createElement(ToggleButton, {
    value: FEE_UNIT_TYPES.percentage
  }, "%")), /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.input, " ").concat(classes.currencyToggler)
  }, /*#__PURE__*/React.createElement(FormControl, {
    variant: "outlined",
    key: feeName,
    onKeyPress: event => {
      if (!/[0-9]|[.,]/.test(event.key)) {
        event.preventDefault();
      }
    },
    onChange: e => {
      if (!/^\d+([.,]\d{0,2})?$|^$/.test(e.target.value)) return;
      inputHandleChange(e.target.value);
    },
    error: isInputTouched && inputValue === ''
  }, /*#__PURE__*/React.createElement(InputLabel, {
    htmlFor: "lateFee"
  }, t('add_new_property_flow.fee_value')), /*#__PURE__*/React.createElement(OutlinedInput, {
    id: "lateFee",
    name: "lateFee",
    label: t('add_new_property_flow.fee_value'),
    type: "number",
    placeholder: "0.00",
    value: (_store$addNewProperty8 = store.addNewProperty.feeStructureV2.getPropertyFee({
      feeName
    })) === null || _store$addNewProperty8 === void 0 ? void 0 : _store$addNewProperty8.value,
    onBlur: handleTouched,
    startAdornment: feeCurrency === FEE_UNIT_TYPES.fixedAmount && /*#__PURE__*/React.createElement(InputAdornment, {
      position: "start"
    }, "$"),
    endAdornment: feeCurrency === FEE_UNIT_TYPES.percentage && /*#__PURE__*/React.createElement(InputAdornment, {
      position: "end"
    }, "%")
  })))))));
});